export default "__VITE_ASSET__B5j7PoFH__"